import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Configuration, DefaultSecurity, StrategicAssetAllocation, TargetsState } from './';
import { fetchConfigurations, fetchDefaultSecurities, fetchStrategicAllocations } from './thunks';

export const initialState: TargetsState = {
  configurations: [],
  strategicAllocations: [],
  defaultSecurities: [],
};

export const targetsSlice = createSlice({
  name: '@@investmentServices/targets',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfigurations.fulfilled, (state: TargetsState, action: PayloadAction<Configuration[]>) => {
      state.configurations = action.payload;
    });

    builder.addCase(fetchStrategicAllocations.fulfilled, (state: TargetsState, action: PayloadAction<StrategicAssetAllocation[]>) => {
      state.strategicAllocations = action.payload;
    });

    builder.addCase(fetchDefaultSecurities.fulfilled, (state: TargetsState, action: PayloadAction<DefaultSecurity[]>) => {
      state.defaultSecurities = action.payload;
    });
  },
});
